import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useCart } from '../contexts/CartContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';

const CartIcon: React.FC = () => {
  const { getCartTotal } = useCart();
  const cartTotal = getCartTotal();
  const navigate = useNavigate();

  const handleCartClick = () => {
    navigate('/cart');
  };

  return (
    <div className="relative">
      <button
        onClick={handleCartClick}
        className="p-2 text-earth-700 hover:text-sage-700 focus:outline-none transition-colors duration-300 relative"
        aria-label="Shopping cart"
      >
        <motion.div whileHover={{ scale: 1.1 }} transition={{ type: "spring", stiffness: 300 }}>
          <FontAwesomeIcon icon={faShoppingCart} className="h-6 w-6" />

          {cartTotal > 0 && (
            <motion.span
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              className="absolute -top-1 -right-1 bg-sage-600 text-cream-50 text-xs font-semibold rounded-sm h-5 w-5 flex items-center justify-center border border-sage-700"
              style={{
                boxShadow: '0 2px 6px rgba(90, 125, 82, 0.25)'
              }}
            >
              {cartTotal}
            </motion.span>
          )}
        </motion.div>
      </button>
    </div>
  );
};

export default CartIcon;